// DISABLED — DO NOT SHOW CLEARANCE POPUP
return;

// ===============
// FREE CLEARANCE POPUP
// ===============
var CLEARANCE_COLLECTION_URL = '/collections/clearance-65-off';

// Check cart and trigger popup
function checkAndShowClearancePopup() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      if (!cart || !cart.items || cart.items.length === 0) return;

      // ⏱ GLOBAL 20-second throttle
      let lastShown = sessionStorage.getItem('clearance_last_shown');
      let now = Date.now();
      if (lastShown && now - lastShown < 20000) {
        return; // still within delay window
      }

      // Check if any item in cart is marked as clearance
      let hasClearance = cart.items.some(item => 
        item.properties && item.properties.is_clearance === "true"
      );

      // If a clearance item is in cart → do NOT show popup
      if (hasClearance) return;

      // Show popup + stamp timestamp
      showClearanceInfoPopup();
      sessionStorage.setItem('clearance_last_shown', Date.now());
    })
    .catch(err => console.error('Cart error (clearance popup):', err));
}

// Build the popup
function showClearanceInfoPopup() {
  sessionStorage.setItem('clearance_last_shown', Date.now());

  const overlay = document.createElement('div');
  overlay.style = `
    position: fixed;
    inset: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: opacity 0.35s ease;
    z-index: 10000;
    padding: 40px 16px;
    box-sizing: border-box;
  `;

  const modal = document.createElement('div');
  modal.style = `
    background: #fff;
    color: #000;
    padding: 24px 20px;
    max-width: 480px;
    width: 100%;
    text-align: center;
    font-family: Helvetica, Arial, sans-serif;
    font-size: 12px;
    letter-spacing: 0.05em;
    border-radius: 0px;
    border: 1px solid #e6e6e6;
    box-shadow: 0 8px 24px rgba(0,0,0,0.2);
    transform: scale(0.96);
    transition: transform 0.35s ease;
    box-sizing: border-box;
  `;

  modal.innerHTML = `
    <h2 style="font-size: 12px; text-transform: uppercase; letter-spacing: 0.12em; margin-bottom: 12px; font-weight: 600;">
      FREE SELECTED ITEM UNLOCKED
    </h2>
    <p style="font-size: 11px; line-height: 1.6; margin-bottom: 20px; letter-spacing: 0.04em;">
      CHOOSE ANY SELECTED ITEM FOR FREE.
    </p>
    <a href="${CLEARANCE_COLLECTION_URL}"
       style="
         display: inline-block;
         padding: 10px 20px;
         border-radius: 0px;
         background: #000;
         color: #fff;
         text-decoration: none;
         text-transform: uppercase;
         font-size: 11px;
         font-weight: 600;
         letter-spacing: 0.12em;
         margin-bottom: 10px;
       ">
      BROWSE SELECTED
    </a>
    <div id="clearance-modal-close"
         style="margin-top: 10px; font-size: 10px; color: #999; cursor: pointer; text-decoration: underline; text-transform: uppercase; letter-spacing: 0.08em;">
      Continue shopping
    </div>
  `;

  overlay.appendChild(modal);
  document.body.appendChild(overlay);

  requestAnimationFrame(() => {
    overlay.style.opacity = '1';
    modal.style.transform = 'scale(1)';
  });

  // Close logic
  document.getElementById('clearance-modal-close').addEventListener('click', () => {
    overlay.style.opacity = '0';
    modal.style.transform = 'scale(0.96)';
    setTimeout(() => overlay.remove(), 300);
  });

  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) {
      overlay.style.opacity = '0';
      modal.style.transform = 'scale(0.96)';
      setTimeout(() => overlay.remove(), 300);
    }
  });
}

// ===============
// TRIGGERS
// ===============
document.addEventListener('DOMContentLoaded', () => {
  if (window.location.pathname === '/cart') {
    checkAndShowClearancePopup();
  }

  // Watch cart drawer changes
  const observer = new MutationObserver(() => {
    checkAndShowClearancePopup();
  });

  const cartContainer = document.querySelector('[id*="CartDrawer"], .cart__contents, .cart-items');
  if (cartContainer) {
    observer.observe(cartContainer, { childList: true, subtree: true });
  }

  document.body.addEventListener('cart:updated', () => {
    checkAndShowClearancePopup();
  });
});